<template>
  <div class="icon-container" @click="openWindow">
    <!-- Facebook -->
    <svg v-if="network == 'facebook'" width="11" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M8.768 3.32c-.457 0-.826.078-1.105.235-.254.156-.42.351-.496.586-.076.234-.114.533-.114.898V7.5h3.24l-.457 3.555H7.053V20H3.47v-8.945H.535V7.5H3.47V4.687c0-1.484.407-2.63 1.22-3.437C5.503.417 6.583 0 7.93 0c1.092 0 1.982.052 2.668.156V3.32h-1.83z" fill="#162F47"/></svg>
    <!-- LinkedIn -->
    <svg v-if="network == 'linkedin'" width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M4.356 20H.305V6.652h4.051V20zM4.008 4.107c-.465.476-1.017.714-1.656.714s-1.19-.238-1.655-.714A2.346 2.346 0 010 2.411C0 1.756.232 1.19.697.714 1.162.238 1.713 0 2.352 0c.64 0 1.191.238 1.656.714.464.476.697 1.042.697 1.697 0 .654-.233 1.22-.697 1.696zM19.516 20h-4.051v-6.518c0-.387-.015-.7-.044-.937 0-.268-.044-.58-.13-.938-.059-.357-.16-.64-.306-.848-.116-.208-.32-.387-.61-.536-.26-.178-.595-.268-1.002-.268-.958 0-1.611.313-1.96.938-.32.625-.479 1.458-.479 2.5V20H6.883V6.652h3.92v1.83h.044c.29-.595.77-1.101 1.438-1.518.667-.446 1.466-.67 2.395-.67.988 0 1.8.164 2.44.492.668.297 1.162.759 1.48 1.384.35.595.582 1.25.698 1.964.145.714.218 1.562.218 2.545V20z" fill="#162F47"/></svg>
    <!-- Twitter -->
    <svg v-if="network == 'twitter'" width="20" height="18" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 512 462.799"><path fill="#162F47" fill-rule="nonzero" d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"/></svg>
    <!-- WhatsApp -->
    <svg v-if="network == 'whatsapp'" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg"><path d="M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z" fill="#162F47"/></svg>
  </div>
</template>

<script>
export default {
  name: 'SocialMediaShare',

  props: {
    network: { // facebook/linkedin/twitter/whatsapp
      type: String
    },
    url: { // URL to share.
      type: String,
      default: window.location.href
    },
    title: { // Sharing title (if available).
      type: String
    },
    description: {  // Sharing description (if available).
      type: String
    },
    quote: {  // Facebook quote (Facebook only).
      type: String
    },
    hashtags: {  // A list of comma-separated hashtags (Twitter and Facebook).
      type: String,
      default: '#escapethecity,#EsctheCity'
    },
    popup: {
      type: Object,
      default: {width: 960, height: 600}
    },
  },

	data() {
		return {
      facebookId: '538201487366504'
		}
	},

	methods: {
    openWindow() {
      // url, windowName, [windowFeatures]
      window.open(this.link, this.title, `resizable=yes,width=${this.popup.width},height=${this.popup.height}`);
    }
	},

  computed: {
    link() {
      let networkLink;
      switch (this.network) {
        case 'facebook':
          networkLink = `https://www.facebook.com/dialog/share?app_id=${this.facebookId}&display=popup&href=${this.url}`;
          break;
        case 'linkedin':
          networkLink = `https://www.linkedin.com/sharing/share-offsite/?url=${this.url}`;
          break;
        case 'twitter':
          networkLink = `https://twitter.com/intent/tweet?text=${this.title}&url=${this.url}&related=`;
          break;
        case 'whatsapp':
          networkLink = `https://api.whatsapp.com/send?text=${this.title}%20${this.url}`;
          break;
      }
      return networkLink;
    },
  }
}
</script>
